module.exports = "https://cdn.thelire.com/ins/resource/coins_1.e0975a706237e1eb8483554abc542439.png";